/* ==========================================================================
   PARROTTY — Cart drawer on mobile: suppress the AUTO-open after
   add-to-cart, but keep the drawer working for an explicit click on the
   cart icon.

   Mobile already has its own "item added" feedback (the bottom toast,
   nura-mobile-toast.css + nura-tabbar-cart-live.js), so we don't also
   want the side drawer popping up every time someone adds a product —
   that's redundant with the toast and feels heavy on a small screen.
   But if the shopper deliberately taps the cart icon to go look at their
   cart, they should get the side drawer, not be sent to a separate page.

   Patches CartDrawer.prototype.open after cart-drawer.js defines the
   class, without editing that core file (same approach already used by
   nura-cart-notification-name.js for <cart-notification>).

   Two call sites in cart-drawer.js reach open(), distinguished here by
   their existing call signature — no guessing required:
     - open() with NO argument — the automatic open after a successful
       add-to-cart (from renderContents()). On mobile this is now a
       no-op: the toast already covers "added" feedback on its own.
     - open(triggeredBy) — a real user click on the header cart icon.
       On mobile this now behaves exactly like desktop: the drawer opens
       normally (originalOpen is called unmodified). It no longer
       navigates to the cart page.
   ========================================================================== */
(function () {
  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  var attempts = 0;
  var MAX_ATTEMPTS = 100;

  function patch() {
    attempts++;

    if (!window.customElements || !customElements.get('cart-drawer')) {
      if (attempts < MAX_ATTEMPTS) {
        setTimeout(patch, 50);
      }
      return;
    }

    var CartDrawerEl = customElements.get('cart-drawer');
    var proto = CartDrawerEl.prototype;

    if (!proto || proto.__nuraMobileAutoOpenDisablePatched || typeof proto.open !== 'function') {
      return;
    }

    var originalOpen = proto.open;

    proto.open = function (triggeredBy) {
      if (isMobile() && !triggeredBy) {
        /* Automatic open after add-to-cart: skip it, the toast already
           handled that feedback. */
        return;
      }
      /* Explicit click on the cart icon (triggeredBy present), on any
         viewport size — open the drawer normally. */
      return originalOpen.call(this, triggeredBy);
    };

    proto.__nuraMobileAutoOpenDisablePatched = true;
  }

  patch();
})();
